import { Component, inject } from '@angular/core';

import { SurveyEditorService } from '../../../../services/survey-editor.service';

@Component({
  selector: 'empathy-hidden-question-settings',
  templateUrl: 'hidden-question-settings.component.html',
  styleUrls: ['./hidden-question-settings.component.scss', './_hidden-question-settings-theme.component.scss']
})
export class HiddenQuestionSettingsComponent {
  surveyEditorService = inject(SurveyEditorService);
}
